export default {
  "app.title": "Bait Henna | Management & Sales",
  "language.switch": "Switch to Arabic",
  "brand.name": "Bait Henna & Herbs",
  "brand.logo": "Bait Henna & Herbs logo",
  "brand.tagline": "Natural care · Herbs",
  "common.back": "Back",
  "common.close": "Close",
  "common.search": "Search...",
  "common.empty": "No data yet",
  "common.emptyDescription": "Data will appear here when added.",
  "common.synced": "Synced",
  "common.retry": "Try again",
  "common.loading": "Loading…",
  "common.product": "Product",
  "common.status": "Status",
  "common.total": "Total",
  "common.customer": "Customer",
  "common.payment": "Payment method",
  "common.invoiceNo": "Invoice number",
  "app.preparing": "Preparing Bait Henna & Herbs...",
  "app.update": "An app update is available",
  "app.updateNow": "Update now",
  "app.leaveTitle": "Leave this screen?",
  "app.stay": "Stay here",
  "app.leave": "Leave anyway",
  "nav.home": "Home",
  "nav.overview": "Overview",
  "nav.salesCustomers": "Sales & customers",
  "nav.dailySales": "Daily sales",
  "nav.sales": "Sales",
  "nav.customerFiles": "Customer records",
  "nav.customers": "Customers",
  "nav.legacySales": "Imported sales",
  "nav.legacy": "Imported",
  "nav.productsInventory": "Products & inventory",
  "nav.productFiles": "Product catalog",
  "nav.products": "Products",
  "nav.inventoryCount": "Inventory & stocktaking",
  "nav.inventory": "Inventory",
  "nav.purchases": "Purchases",
  "nav.expensesFull": "Expenses & incidentals",
  "nav.expenses": "Expenses",
  "nav.suppliers": "Suppliers",
  "nav.pricingFull": "Prices & quotations",
  "nav.pricing": "Prices",
  "nav.marginsFull": "Margin review",
  "nav.margins": "Margins",
  "nav.dateLabels": "Date labels",
  "nav.labels": "Labels",
  "nav.reportsAdmin": "Reports & administration",
  "nav.pnl": "Profit & loss",
  "nav.profit": "Profit",
  "nav.vatReturn": "VAT return",
  "nav.tax": "Tax",
  "nav.reports": "Reports",
  "nav.employeesFull": "Employees & permissions",
  "nav.employees": "Employees",
  "nav.auditFull": "Audit log",
  "nav.audit": "Audit",
  "nav.accountFull": "Account settings",
  "nav.account": "Account",
  "nav.selling": "Sell",
  "nav.pos": "Point of sale",
  "nav.all": "All sections",
  "nav.sections": "Sections",
  "nav.logout": "Sign out",
  "nav.out": "Sign out",
  "nav.main": "Main navigation",
  "nav.open": "Open sections",
  "nav.profile": "My account and sections",
  "nav.quick": "Quick navigation",
  "nav.more": "More",
  "role.admin": "Administrator",
  "role.cashier": "Sales associate",
  "sync.connected": "Live sync",
  "sync.offline": "Reconnecting",
  "sync.connecting": "Connecting",
  "theme.light": "Switch to light mode",
  "theme.dark": "Switch to dark mode",
  "combo.empty": "No matching option — enter a new value",
  "combo.new": "New value — added when saved",
  "combo.open": "Open {label} options",
  "login.welcome": "Welcome to Bait Henna & Herbs",
  "login.description": "Sign in to manage your business or start selling at the checkout.",
  "login.identifier": "Mobile number or email",
  "login.placeholder": "name@example.com or 05xxxxxxxx",
  "login.password": "Password",
  "login.hide": "Hide password",
  "login.show": "Show password",
  "login.forgot": "Forgot your password?",
  "login.busy": "Signing in...",
  "login.submit": "Sign in",
  "login.newEmployee": "New employee? Create a sales account",
  "login.approvalHint": "Your request will be sent to management for approval",
  "login.back": "Back to sign in",
  "login.recoverySent": "Recovery request sent",
  "login.recoverySentHint": "Management will receive your request to set a temporary password.",
  "login.recovery": "Password recovery",
  "login.recoveryHint": "Enter your registered mobile number or email to send a secure request to management.",
  "login.sending": "Sending request...",
  "login.requestRecovery": "Send recovery request",
  "login.registered": "Request sent",
  "login.registeredHint": "Your account will appear in the management dashboard. You can sign in after approval.",
  "login.create": "Create a sales account",
  "login.createHint": "Enter your details. Your account will be activated after management approval.",
  "login.name": "Full name",
  "login.namePlaceholder": "Name as shown on invoices",
  "login.phone": "Mobile number",
  "login.email": "Email",
  "login.confirmPassword": "Confirm password",
  "login.registerSubmit": "Create account and send for approval",
  "login.security": "Encrypted session with individual employee permissions",
  "login.quote": "“Every detail in one place, from the first sale to the last item in stock.”",
  "login.teamQuote": "“One team, connected sales, and management that stays up to date.”",
  "login.system": "The integrated operations system for Bait Henna & Herbs",
  "errors.passwordMismatch": "Passwords do not match",
  "errors.requestFailed": "Unable to complete the request",
  "errors.network": "Unable to reach the server. Check your connection and try again.",
  "errors.invalidCredentials": "Incorrect sign-in details",
  "errors.pendingAccount": "Your account is awaiting management approval",
  "errors.suspendedAccount": "Your account is suspended. Contact management.",
  "errors.loginRateLimit": "Too many attempts. Try again in {seconds} seconds.",
  "errors.registerRateLimit": "Too many registration attempts. Try again later.",
  "errors.nameRequired": "Name is required",
  "errors.invalidPhone": "Enter a valid Saudi mobile number starting with 05",
  "errors.invalidEmail": "Enter a valid email address",
  "errors.shortPassword": "Password must be at least 8 characters",
  "errors.duplicateAccount": "Mobile number or email is already registered",
  "errors.identifierRequired": "Enter your mobile number or email",
  "dashboard.trendLabel": "Sales over the last 14 days",
  "dashboard.last14": "Last 14 days",
  "dashboard.today": "Today",
  "dashboard.daySheet": "Today’s summary",
  "dashboard.netSales": "Today’s net sales",
  "dashboard.profitNotes": "Profit calculation notes",
  "dashboard.transparency": "The figures include the limitations below.",
  "dashboard.fillCosts": "Enter costs",
  "dashboard.reviewMargins": "Review margins",
  "dashboard.summary": "Today’s business performance",
  "dashboard.live": "Live",
  "dashboard.loading": "Loading data…",
  "dashboard.noComparison": "No sales yesterday to compare",
  "dashboard.completed": "Completed sales invoices",
  "dashboard.profitBasis": "After costs and discounts, excluding tax",
  "dashboard.invoiceCount": "Sales invoices",
  "dashboard.average": "Average order value",
  "dashboard.perInvoice": "Per sales invoice",
  "dashboard.newCustomers": "New customers",
  "dashboard.registeredToday": "Registered today",
  "dashboard.profit": "Estimated profit",
  "dashboard.stockAlerts": "Stock alerts",
  "dashboard.viewAll": "View all",
  "dashboard.available": "Available",
  "dashboard.minimum": "Minimum",
  "dashboard.low": "Low",
  "dashboard.stockGood": "Stock levels are healthy",
  "dashboard.noLowStock": "No products are currently below their alert level",
  "dashboard.recent": "Recent invoices",
  "dashboard.noInvoices": "No invoices today",
  "dashboard.newInvoicesHint": "New invoices will appear here automatically",
  "dashboard.held": "Held sales",
  "dashboard.heldHint": "Not completed sales; excluded from reports",
  "dashboard.noHeld": "No held sales",
  "dashboard.noHeldHint": "Sales appear here when put on hold",
  "dashboard.topProducts": "Best-selling products",
  "dashboard.byQuantity": "By quantity sold today",
  "dashboard.noSales": "No sales yet",
  "dashboard.topHint": "Best-selling products will appear here",
  "dashboard.quick": "Quick actions",
  "dashboard.newPurchase": "Create purchase order",
  "dashboard.purchaseHint": "Receive a new stock delivery",
  "dashboard.newQuote": "Create quotation",
  "dashboard.quoteHint": "Prepare a customer quotation",
  "dashboard.change": "{change}% vs yesterday",
  "dashboard.returns": {
    "one": "{count} return totalling {amount}",
    "other": "{count} returns totalling {amount}"
  },
  "dashboard.margin": "{margin}% margin · after costs and discounts, excluding tax",
  "dashboard.updated": "Last updated: {time}",
  "dashboard.now": "Just now",
  "dashboard.minutesAgo": {
    "one": "{count} minute ago",
    "other": "{count} minutes ago"
  },
  "dashboard.hoursAgo": {
    "one": "{count} hour ago",
    "other": "{count} hours ago"
  },
  "dashboard.attention": {
    "one": "{count} product needs attention",
    "other": "{count} products need attention"
  },
  "dashboard.invoicesToday": {
    "one": "{count} invoice · today",
    "other": "{count} invoices · today"
  },
  "dashboard.heldDetails": "{employee} · {count} items · {date}",
  "dashboard.unitsSold": {
    "one": "{count} unit sold",
    "other": "{count} units sold"
  },
  "dashboard.uncovered": "Today’s sales include {amount} from {count} products without recorded costs, excluded from profit to avoid overstating it.",
  "dashboard.missingCosts": "{count} active products have no recorded cost.",
  "dashboard.negativeMargin": "{count} products cost as much as, or more than, their selling price; sales may incur a loss.",
  "dashboard.openAmount": "Open-amount sales account for {share}% of today’s sales ({amount}). Their profit uses an estimated cost ratio rather than purchase invoices.",
  "payment.cash": "Cash",
  "payment.card": "Card",
  "payment.credit": "On account",
  "payment.balance": "Customer credit",
  "payment.split": "Split payment",
  "status.credit": "On account",
  "status.paid": "Completed",
  "status.return": "Returned",
  "install.installed": "App installed",
  "install.where": "Where to find the app",
  "install.button": "Install app",
  "install.alreadyButton": "App installed — where is it?",
  "install.title": "Install Bait Henna & Herbs",
  "install.alreadyHint": "The app is already installed on this device, so the browser will not show another installation prompt.",
  "install.description": "Install the system as a standalone app with its own window and app icon.",
  "install.location": "Where is the app after installation?",
  "install.windows": "On Windows",
  "install.windowsHint": "A desktop shortcut is not created automatically. Search the Start menu for “بيت الحناء”, or open chrome://apps in Chrome. Right-click the app in Start to pin it to the taskbar or open its file location to create a desktop shortcut.",
  "install.android": "On Android",
  "install.androidHint": "Look in the app drawer or on the home screen. Swipe up and search for “بيت الحناء” if you cannot find it.",
  "install.ios": "On iPhone and iPad",
  "install.iosHint": "In Safari, tap Share, then Add to Home Screen. Use Safari to install on iPhone or iPad.",
  "install.browser": "Install from the browser menu",
  "install.browserHint": "If the button does not work, open Chrome’s menu (⋮), then Cast, save and share or Apps, and choose Install Bait Henna. On Windows, you can also use the install icon in the address bar.",
  "install.iconHint": "To refresh an installed app’s icon, uninstall it from the device and install it again.",
  "payment.bank": "Bank transfer",
  "payment.transfer": "Transfer",
  "payment.multi": "Split payment",
  "status.completed": "Completed",
  "status.settled": "Paid",
  "status.partReturned": "Partially returned",
  "account.title": "Account settings",
  "account.description": "Edit your username, mobile number, and password",
  "account.protected": "Protected account",
  "account.userData": "User details",
  "account.userDataHint": "Your updated name will appear in the top bar and on future activity.",
  "account.username": "Username",
  "account.email": "Email address",
  "account.phone": "Mobile number (used to sign in)",
  "account.passwordSection": "Verify identity and change password",
  "account.passwordHint": "Your current password is required when changing your mobile number or password.",
  "account.currentPassword": "Current password",
  "account.newPassword": "New password",
  "account.confirmPassword": "Confirm new password",
  "account.saving": "Saving...",
  "account.save": "Save changes",
  "account.securityTitle": "Account security",
  "account.securityDescription": "Changing your password will sign out all other sessions while keeping your current session active.",
  "account.securityLength": "Use at least 8 characters",
  "account.securityShare": "Do not share your password with any employee",
  "account.securitySeller": "Each salesperson has an individual account linked to their sales",
  "account.errorPasswordMismatch": "The new passwords do not match",
  "account.errorPhone": "Enter a valid Saudi mobile number starting with 05",
  "account.errorCurrentPassword": "Enter your current password to confirm the change",
  "account.noChange": "No changes to save",
  "account.updated": "Updated: {fields}",
  "dateLabels.title": "Product date labels",
  "dateLabels.description": "Choose a product, set its production and expiry dates, then print a label for municipal requirements.",
  "dateLabels.noticeTitle": "Display-compliant label",
  "dateLabels.noticeDescription": "Attach one to each package before display. Staff enter the product name and production and expiry dates.",
  "dateLabels.search": "Search by name, SKU, or barcode...",
  "dateLabels.count": {
    "one": "{count} product",
    "other": "{count} products"
  },
  "dateLabels.product": "Product",
  "dateLabels.code": "Code",
  "dateLabels.category": "Category",
  "dateLabels.action": "Action",
  "dateLabels.printDate": "Print date label",
  "dateLabels.openAmount": "Open amount",
  "dateLabels.empty": "No matching products",
  "dateLabels.modalTitle": "Date label — {name}",
  "dateLabels.production": "Production date",
  "dateLabels.expiry": "Expiry date",
  "dateLabels.sizePortrait": "Vertical 4.5×6.5 cm — 6.5×4.5 paper",
  "dateLabels.sizeLandscape": "Horizontal 6.5×4.5 cm",
  "dateLabels.sizeMedium": "Medium label",
  "dateLabels.brandLogo": "Bait Henna & Herbs logo",
  "dateLabels.expiresOn": "Expires on",
  "dateLabels.errorProduction": "Select a production date",
  "dateLabels.errorExpiry": "Select an expiry date",
  "dateLabels.errorOrder": "Expiry date is before production date",
  "dateLabels.printHint": "Print vertically at 4.5×6.5 cm, centered on 6.5×4.5 paper. Set margins to None and scale to 100%.",
  "dateLabels.close": "Close",
  "dateLabels.print": "Print label",

};
